'use es6';

import getIn from 'transmute/getIn';
import { OFFICE_HOURS_START_TIME } from '../constants/keyPaths';
export const getOfficeHoursMessageStartTime = getIn(OFFICE_HOURS_START_TIME);
export const getOfficeHoursStartTime = message => {
  return getOfficeHoursMessageStartTime(message);
};